import React, {useState, useEffect} from 'react';
import {Box, Typography, Paper, Divider, Icon} from '@mui/material';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import PersonIcon from '@mui/icons-material/Person';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import BugReportIcon from '@mui/icons-material/BugReport';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import NavBar from '../../pieces/navbar/navbar';
import {globalUseClasses} from '../../styles/globalClasses';

/**
 * CallLogs component - displays call logs in a scrollable list
 * Based on Vue CallLogs.vue component
 */
const CallLogs = () => {
  const classes = globalUseClasses();
  const [logs, setLogs] = useState([]);

  // TODO: Connect to Redux store or API to fetch actual call logs
  // For now, using empty array - can be populated from props or store
  useEffect(() => {
    // Example: Fetch logs from store or API
    // const logs = useSelector(state => state.callLogs?.logs || []);
    // setLogs(logs);
  }, []);

  const formatTime = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
    }).format(d);
  };

  const iconForType = (type) => {
    switch (type) {
      case 'user':
        return <PersonIcon fontSize="small" />;
      case 'agent':
        return <SmartToyIcon fontSize="small" />;
      case 'debug':
        return <BugReportIcon fontSize="small" />;
      case 'completed':
        return <CheckCircleIcon fontSize="small" />;
      default:
        return <InfoIcon fontSize="small" />;
    }
  };

  const colorForType = (type) => {
    switch (type) {
      case 'user':
        return 'primary';
      case 'agent':
        return 'text.secondary';
      case 'debug':
        return 'info';
      case 'completed':
        return 'success';
      default:
        return 'info';
    }
  };

  return (
    <Box sx={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
      <NavBar />
      <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
        <Paper
          elevation={2}
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            m: 2,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 2,
              pb: 1,
              pt: 2,
            }}
          >
            <MonitorHeartIcon sx={{mr: 1}} />
            <Typography variant="h6">Call Logs</Typography>
          </Box>

          <Divider />

          {/* Scrollable logs area */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              px: 2,
              pt: 2,
            }}
          >
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    py: 0.5,
                    gap: 1,
                  }}
                >
                  {/* Time */}
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'text.secondary',
                      minWidth: '80px',
                      flexShrink: 0,
                    }}
                  >
                    {formatTime(log.date)}
                  </Typography>

                  {/* Icon */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: `${colorForType(log.type)}.main`,
                      flexShrink: 0,
                    }}
                  >
                    {iconForType(log.type)}
                  </Box>

                  {/* Message */}
                  <Typography variant="body2" sx={{flex: 1}}>
                    {log.message}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography variant="body2" sx={{color: 'text.secondary'}}>
                No call logs yet.
              </Typography>
            )}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default CallLogs;
